var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.base}`},[_c('WorkflowCallout',{staticClass:"mt-2",attrs:{"title":_vm.$t(`${_vm.pre}.title`),"description":_vm.$t(`${_vm.pre}.description`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }